import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=72b30724&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=72b30724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b30724",
  null
  
)

export default component.exports